module.exports = __webpack_public_path__ + "img/vertical_3_5_5012.86bd969d.png";